module.exports = __webpack_public_path__ + "imgs/gazpromMobile.95545c7c.webp";